// ast-grep-ignore: no-absolute-fortune-urls

export function userTokenCookieDomain() {
  const baseUrl = process.env.SITE_BASE_URL || '';
  const deployedBaseUrLs = [
    'https://develop.fortune.com',
    'https://staging.fortune.com',
    'https://qa.fortune.com',
    'https://fortune.com',
  ];
  if (deployedBaseUrLs.includes(baseUrl)) {
    return { domain: `.${window.location.hostname}` };
  }
  return {};
}
